import React from 'react';
import { MARK, MARK_HEIGHT, MARK_WIDTH } from '../lib/waLogo';

/**
 * The mark: the solid WA ligature from the opening (candidate B, the
 * storyboard's 1.66 s frame) - the W's last stroke is also the A's left leg,
 * and the A's bar comes back up from its right foot. The outline itself lives
 * in lib/waLogo.js, where the intro settles on exactly this shape; it is one
 * flattened path (an outline and the A's counter), so it renders solid under
 * any fill rule and at any size. Drawn in currentColor; public/favicon.svg
 * and the PNG icons are the same path on a dark tile (scripts/make-icons.js).
 */
export const Mark = ({ className = 'mark' }) => (
  <svg className={className} viewBox={`0 0 ${MARK_WIDTH} ${MARK_HEIGHT}`} fill="currentColor" aria-hidden="true" focusable="false">
    <path d={MARK} />
  </svg>
);

/** Mark and name together, as the header and the sign-in card show it. */
const Logo = () => (
  <>
    <Mark />
    <span className="brand-name">
      watchanything<span className="brand-tld">.stream</span>
    </span>
  </>
);

export default Logo;
